import React from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import arrowRightSVG from 'fcmh/theme/assets/icons/arrow-right.svg';
import { useIntl } from 'react-intl';
import messages from '../../../messages';

const resolveLink = (val) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return resolveLink(val[0]);
  if (val['@id']) return flattenToAppURL(val['@id']);
  if (val.url) return val.url;
  return '';
};

// Format helper
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('de-DE');
};

const EventsVariation = ({
  items = [],
  isEditMode = false,
  headline,
  moreLinkHref,
  moreLinkLabel,
}) => {
  const intl = useIntl();
  const visible = items.slice(0, 3);

  return (
    <section className="events-cards">
      {headline && <h2 className="events-cards__headline">{headline}</h2>}

      <div className="events-cards__grid">
        {visible.map((item, i) => {
          const rawId = item?.['@id'];
          const href = rawId ? flattenToAppURL(rawId) : '#';

          const date = item?.start ? formatDate(item.start) : '';
          const title = item?.title || 'Veranstaltung';
          const location = item?.location || '';

          return (
            <article key={i} className="event-card">
              <UniversalLink
                href={href}
                className="event-card__link-wrapper"
                aria-label={`Weiterlesen: ${title}`}
                disabled={isEditMode}
              >
                {date && <div className="event-card__date">{date}</div>}

                <h3 className="event-card__title">{title}</h3>

                {location && (
                  <div className="event-card__location">
                    <span className="event-card__location-label">
                      Veranstaltungsort
                    </span>
                    <p className="event-card__location-text">{location}</p>
                  </div>
                )}

                <span className="event-card__more">
                  <Icon name={arrowRightSVG} size="16px" />
                  <span>{intl.formatMessage(messages.readMore)}</span>
                </span>
              </UniversalLink>
            </article>
          );
        })}
      </div>

      {moreLinkHref && moreLinkLabel && (
        <div className="events-cards__footer">
          <UniversalLink
            href={resolveLink(moreLinkHref)}
            className="events-cards__footer-link"
          >
            {moreLinkLabel}
          </UniversalLink>
        </div>
      )}
    </section>
  );
};

EventsVariation.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any),
  isEditMode: PropTypes.bool,
  headline: PropTypes.string,
  moreLinkHref: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  moreLinkLabel: PropTypes.string,
};

export default EventsVariation;
